import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import MyDatePicker from "../../widgets/DatePicker";
import FixButton from "../../widgets/Button";
import addCorso from "../../services/addCorso";
import moment from "moment";
import Utils from "../../utils/utils";
import SelectInput from "../../widgets/SelectInput";
import getCategorieCorsi from "../../services/getCategorieCorsi";

export default class AddCorso extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.section = this.props.section;
		if (this.section == undefined) {
			const pathname = props.location.pathname;
			this.section = pathname.substring(8, pathname.length);
		}

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.userslist = [];

		this.state = {
			testo: "",
			menuBackground: "#ffffff",
			menuItemColor: "#000000",
			fontSize: 50,
			fontBold: false,
			logoPicture: "",
			logoMargin: 0,
			titleColor: "#000000",
			titleSize: 18,
			isLoading: false,
			addElementVisible: false,
			nomeCorso: "",
			anno_accademico: "",
		};

		this.grid = 2;

		this.pageTitle = "Crea nuovo corso";
		this.startDateRef = React.createRef();
		this.endDateRef = React.createRef();

		this.state = {};
	}

	async componentDidMount() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });
		this.categorieCorsi = await getCategorieCorsi(username, token);

		try {
			const categorieCorsi = await getCategorieCorsi(username, token);

			const optionsCategoria = categorieCorsi.map(corso => ({
				value: corso.id,
				label: corso.name,
			}));

			this.setState({
				categorieCorso: categorieCorsi,
				optionsCategoria,
			});
		} catch (error) {
			console.error("Error fetching categories: ", error);
		}
	}

	lockedSaveCorso = Utils.disallowConcurrency(this.save.bind(this));

	handleChange = option => {
		this.setState({ selectedCategoriaCorso: option });
	};

	render() {
		function createData(username, name, surname) {
			return { username, name, surname };
		}

		var rows = [];
		this.userslist.length > 0 &&
			this.userslist.map((v, k) => {
				rows.push(createData(v.username, v.name, v.surname));
			});

		return (
			<>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={this.pageTitle} />

					<div key={Math.random()}>
						<SelectInput
							value={this.state.selectedCategoriaCorso}
							name="Categoria"
							hidable={false}
							options={this.state.optionsCategoria}
							isMulti={false}
							onChange={this.handleChange}
						/>
					</div>
					<TextInput
						name={"Nome"}
						value={this.state.nomeCorso}
						onChange={text => {
							this.setState({ nomeCorso: text });
						}}
					/>

					<MyDatePicker ref={this.startDateRef} name={"Data inizio"} />
					<MyDatePicker ref={this.endDateRef} name={"Data fine"} />

					<TextInput
						name={"Anno accademico"}
						value={this.state.anno_accademico}
						onChange={text => {
							this.setState({ anno_accademico: text });
						}}
					/>

					<FixButton title={"Salva"} callback={this.state.isLoading ? () => {} : this.lockedSaveCorso} />
				</LoadingOverlay>
			</>
		);
	}

	async save() {
		this.setState({ isLoading: true });
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		const xStartDate = this.startDateRef.current.getDate();
		const xEndDate = this.endDateRef.current.getDate();

		let startDate = moment(xStartDate).format("yyyy-MM-DD");
		let endDate = moment(xEndDate).format("yyyy-MM-DD");

		if (xEndDate < xStartDate) {
			alert("Controlla le date del corso per favore");
			this.setState({ isLoading: false });
			return;
		}

		if (this.state.selectedCategoriaCorso == undefined) {
			alert("Seleziona una categoria per il corso");
			this.setState({ isLoading: false });
			return;
		}

		let ret = await addCorso(
			username,
			token,
			this.state.nomeCorso,
			startDate,
			endDate,
			this.state.anno_accademico,
			this.state.selectedCategoriaCorso.value
		);

		if (ret.result == "ok") {
			this.setState({ isLoading: false });
			window.location.href = "/#/app/corsi";
		} else {
			this.setState({ isLoading: false });
			alert("Si è verificato un errore inatteso durante la creazione del corso. Per favore riprova.");
		}
	}
}
